import { observer } from "mobx-react";
import React, { useContext } from "react";

import CashoutButtonCore from "@features/my-bets/shared/cashout/CashoutButtonCore";
import CashoutIndicator from "@features/my-bets/shared/cashout/CashoutIndicator";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import classNames from "classnames";

import EmptyCashoutButtonCore from "./EmptyCashoutButtonCore";

export default observer(function CashoutButton() {
	const bet = useContext(MyBetsBetContext);
	const store = useContext(MyBetsStoreContext);

	if (store == null) {
		console.error("Expected store, got null");
		return null;
	}
	if (bet == null) {
		console.error("Expected bet got null");
		return null;
	}

	if (bet.cType == undefined) {
		console.error("cType can not be null");
		return null;
	}

	if (
		bet.displayedAmount == null ||
		(bet.displayedAmount != null && bet.displayedAmount < "1")
	) {
		return <EmptyCashoutButtonCore />;
	}

	const buttonClasses = classNames(
		"card--bet__btn card--bet__btn--cash btn btn--sml btn--cashout btn--icon",
		{
			inc: bet.indicator === 1,
			dec: bet.indicator === -1,
		}
	);

	const cashOutModalData: Parameters<
		(typeof store)["cashoutStore"]["openCashoutModal"]
	>[0] = {
		userId: bet.userId || "",
		id: bet.id,
		calculatedCashoutAmount: bet.calculatedCashoutAmount,
		displayedAmount: bet.displayedAmount,
		cType: bet.cType,
		isChangeAccepted: bet.isChangeAccepted,
		isLive: bet.isLive,
		liveBetSlipCountdown: bet.liveBetSlipCountdown,
	};

	return (
		<button
			type="button"
			className={buttonClasses}
			disabled={store.cashoutStore.isCashoutFormSubmitting}
			onClick={() =>
				store.cashoutStore.openCashoutModal(cashOutModalData)
			}
		>
			<CashoutIndicator />
			<CashoutButtonCore />
		</button>
	);
});
